import {Diy3PC} from "../../features/diy/Diy3PC"

export default Diy3PC.Page
